module.exports = __webpack_public_path__ + "img/xinjingfuwuzhongxin.f79d21c3.jpg";